import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Customer-facing API — relies on httpOnly session cookie
export const publicApi = axios.create({ baseURL: API, withCredentials: true });

// Admin API — attaches JWT bearer token from localStorage
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const wsUrl = (path) => {
  const base = BACKEND_URL.replace(/^http/, "ws");
  return `${base}/api${path}`;
};

export const categoryMeta = {
  tables: { label: "Tables", icon: "Table2" },
  chairs: { label: "Chairs", icon: "Armchair" },
  linens: { label: "Linens", icon: "Layers" },
  tableware: { label: "Tableware", icon: "Utensils" },
  tents: { label: "Tents & Marquees", icon: "TentTree" },
  "dance-floors": { label: "Dance Floors", icon: "Disc3" },
  lighting: { label: "Lighting", icon: "Lightbulb" },
  climate: { label: "Climate", icon: "Wind" },
  concessions: { label: "Concessions", icon: "IceCreamCone" },
  games: { label: "Games", icon: "Gamepad2" },
  decor: { label: "Decor", icon: "Sparkles" },
  av: { label: "Audio / Visual", icon: "Music" },
};

export const currency = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
